import { defineMessages } from 'react-intl-next';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	committed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-commit-result.label',
		defaultMessage: 'Commit',
		description: 'Search commit label',
	},
	committed: {
		id: 'search-commit-result.committed',
		defaultMessage: 'Committed {formattedDate}',
		description: 'This shows the timestamp of when the commit was made.',
	},
});
